import React, { FC, useCallback, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { RootState } from '../../../store/reducers';
import { ReservationConfirmData, ReservationDetail } from '../../../store/reducers/schedule/reservationConfirmReducer';
import { stateScheduleReservation } from '../../../store/reducers/schedule/scheduleReservationStateReducer';
import {
  POST_SCHEDULE_RESERVATION_UPDATE_INITIAL,
  SCHEDULE_DISPATCH,
  VISITOR_REGISTER_DISPATCH,
} from '../../../store/actions';

interface Props {
  modalShow: boolean;
  onModalShow: () => void;
  onRefresh: () => void;
}

const ScheduleReservationPop: FC<Props> = ({ modalShow, onModalShow, onRefresh }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const SCHEDULE_RESERVATION_POP_CACHE_KEY = 'scheduleReservationPopCache';
  const [companionNumList, setCompanionNumList] = useState<number[]>([]);
  const [isFullBooked, setIsFullBooked] = useState(false); // 全部残り数が０のフラグ
  const [reservationDateTime, setReservationDateTime] = useState('');
  const [selectCompanionNum, setSelectCompanionNum] = useState(0);
  const [errorMessage, setErrorMessage] = useState('');
  const [localSelectEqId, setLocalSelectEqId] = useState(0);

  const { isGetReservationConfirmLoaded, reservationConfirmData } = useSelector<RootState, ReservationConfirmData>(
    (state) => state.schedule.getReservationConfirmReducer,
  );

  const { scheduleReservation } = useSelector<RootState, stateScheduleReservation>(
    (state) => state.schedule.scheduleReservationState,
  );

  useEffect(() => {
    if (reservationConfirmData?.companionUpperLimit !== undefined) {
      const limit = reservationConfirmData.companionUpperLimit;
      const numList: number[] = Array.from({ length: limit + 1 }, (_, i) => i); // 明确类型
      setCompanionNumList(numList);
    }
    const allFull = reservationConfirmData.scheduleReservationList.every((item) => item.remaining <= 0);
    setIsFullBooked(allFull);
    setLocalSelectEqId(scheduleReservation.selectEqId);
    setSelectCompanionNum(scheduleReservation.selectCompanionNum);
  }, [reservationConfirmData, scheduleReservation.selectEqId, scheduleReservation.selectCompanionNum]);

  const onChangeCompanionNum = useCallback((eve: React.ChangeEvent<HTMLSelectElement>) => {
    const selectNum = Number(eve.target.value);
    setSelectCompanionNum(selectNum);
  }, []);

  const onChangeSelectReservationDetail = useCallback((reservationDetail: ReservationDetail) => {
    return (e: React.ChangeEvent<HTMLInputElement>) => {
      setLocalSelectEqId(reservationDetail.eqsId);
    };
  }, []);

  useEffect(() => {
    dispatch({
      type: POST_SCHEDULE_RESERVATION_UPDATE_INITIAL,
    });
    setErrorMessage('');
  }, [dispatch, modalShow]);

  useEffect(() => {
    const year = scheduleReservation.infoDate.substring(0, 4);
    const month = parseInt(scheduleReservation.infoDate.substring(4, 6), 10).toString();
    const day = parseInt(scheduleReservation.infoDate.substring(6, 8), 10).toString();

    const formattedStartTime = `${scheduleReservation.contentStartTime.substring(
      0,
      2,
    )}:${scheduleReservation.contentStartTime.substring(2, 4)}`;

    const formattedEndTime = `${scheduleReservation.contentEndTime.substring(
      0,
      2,
    )}:${scheduleReservation.contentEndTime.substring(2, 4)}`;

    setReservationDateTime(
      `${year}年${month}月${day}日(${scheduleReservation.week}) ${formattedStartTime}~${formattedEndTime}`,
    );
  }, [scheduleReservation]);

  const openReservationCompletePop = useCallback(() => {
    const selectReservationDetail = reservationConfirmData.scheduleReservationList.find(
      (item) => item.eqsId === localSelectEqId,
    );
    if (!selectReservationDetail) {
      if (reservationConfirmData.contentsClassification === 0) {
        setErrorMessage('予約枠を1つ選択してください。');
      } else {
        setErrorMessage('予約枠を1つ選択してください。');
      }
      const modalDialog = document.querySelector('.modal-dialog');
      if (modalDialog) {
        modalDialog.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }
    const popCacheObj = {
      companionNum: selectCompanionNum,
      selectEqId: selectReservationDetail.eqsId,
    };
    sessionStorage.setItem(SCHEDULE_RESERVATION_POP_CACHE_KEY, JSON.stringify(popCacheObj));
    dispatch({
      type: VISITOR_REGISTER_DISPATCH,
      data: {
        contentsId: scheduleReservation.contentsId, // コンテンツコード
        eqsId: selectReservationDetail.eqsId, // 設備シフトID
        contentsDate: scheduleReservation.infoDate, // コンテンツ日付
        startTime: scheduleReservation.contentStartTime, // コンテンツ開始時間
        endTime: scheduleReservation.contentEndTime, // コンテンツ終了時間
        companion: selectCompanionNum, // 同行者数
        contentsName: reservationConfirmData.contentsName, // コンテンツ名
        shopName: scheduleReservation.clubName, // 店舗名
        eqsName: selectReservationDetail.eqsName, // 設備シフト名
        spaceName: selectReservationDetail.spaceName, // 設備設置席名称
        isAnnex: selectReservationDetail.annexFlag === 1, // 別館フラグ
        clubAddress: reservationConfirmData.clubAddress, // クラブ住所
      },
    });
    history.push('/register');
  }, [
    dispatch,
    history,
    scheduleReservation.contentsId,
    scheduleReservation.infoDate,
    scheduleReservation.contentStartTime,
    scheduleReservation.contentEndTime,
    selectCompanionNum,
    reservationConfirmData.contentsName,
    scheduleReservation.clubName,
    localSelectEqId,
    reservationConfirmData.clubAddress,
  ]);

  const onCloseModal = useCallback(() => {
    dispatch({
      type: SCHEDULE_DISPATCH,
      showPopFlag: false,
    });
    onModalShow();
    onRefresh();
  }, [onRefresh, onModalShow]);

  return (
    <>
      <Modal
        show={modalShow}
        onHide={onCloseModal}
        animation
        dialogClassName="p-modal-member__dialog p-modal-member__dialog--width1102 schedule"
        contentClassName="p-modal-member__content"
      >
        {/* <Modal.Header closeButton> */}
        {/*  <Modal.Title>自定义 Content Class</Modal.Title> */}
        {/* </Modal.Header> */}
        <Modal.Body className="p-modal-member__body">
          <button
            type="button"
            className="p-modal-member__close-button"
            aria-label="閉じる"
            onClick={() => onModalShow()}
          />
          <div className="p-modal-member__container">
            <div className="p-modal-member__header">
              <div className="p-modal-member__title p-modal-member__title--medium">体験・見学予約</div>
              {isGetReservationConfirmLoaded && isFullBooked ? (
                <div className="p-modal-member__title p-modal-member__title--small">
                  現在満席のためご予約いただけません。
                </div>
              ) : (
                <></>
              )}
            </div>
            {isGetReservationConfirmLoaded && (
              <div className="p-modal-member__inner u-sp-gap15">
                {errorMessage ? (
                  <>
                    <div className="p-alert-box">
                      <div className="p-alert-box__inner">
                        <div className="p-alert-box__icon">
                          <img src="/images/icons/icon-alert.svg" alt="画像" className="p-icon p-icon--size20" />
                        </div>
                        <div className="p-alert-box__text">{errorMessage}</div>
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}
                <div className="p-reservation-card">
                  <div className="p-reservation-card__header p-reservation-card__header--modal">
                    <div className="p-reservation-card__row-text">
                      {scheduleReservation.clubName}
                      {reservationConfirmData.annexFlag === 1 ? (
                        <span className="c-genre-label c-genre-label--large">別館</span>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="p-reservation-card__title">{reservationConfirmData.contentsName}</div>
                    <div className="p-reservation-card__value p-reservation-card__value--bold">
                      {reservationDateTime}
                    </div>
                  </div>

                  <div className="p-reservation-card__details p-reservation-card__details--modal">
                    {!isFullBooked ? (
                      <div className="p-reservation-card__details-text">
                        {reservationConfirmData.contentsClassification === 0
                          ? '予約枠を1つ選択してください。'
                          : '予約枠を1つ選択してください。'}
                      </div>
                    ) : (
                      <></>
                    )}
                    {reservationConfirmData && reservationConfirmData?.equipmentLayoutPicture ? (
                      <div className="p-detail-list">
                        <div className="p-detail-list__accordion-box p-detail-list__accordion-box--label-none u-gap10 u-sp-gap5">
                          <details className="c-accordion p-detail-list__store-accordion">
                            <summary className="p-detail-list__link-title">配置図を確認</summary>
                          </details>

                          <div className="p-detail-list__link-content u-pt0">
                            <div className="p-detail-list__inner">
                              <div className="p-detail-list__item p-detail-list__item--flex-start">
                                <div className="p-detail-list__value p-detail-list__value--width-full">
                                  <picture className="p-detail-list__picture">
                                    <img
                                      className="p-detail-list__image"
                                      src={
                                        reservationConfirmData?.equipmentLayoutPicture ??
                                        '/images/schedule/no-image-large.jpg'
                                      }
                                      alt=""
                                    />
                                  </picture>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                    <div className="p-reservation-card__space">
                      <div className="p-space-selector">
                        {reservationConfirmData.scheduleReservationList.map((reservationDetail, index) => (
                          <div
                            className="p-space-selector__option"
                            key={`scheduleReservation_${reservationDetail.eqsId}`}
                          >
                            <input
                              type="radio"
                              name="space-selection"
                              id={`space-selection_${reservationDetail.eqsId}`}
                              className="p-space-selector__radio"
                              onChange={onChangeSelectReservationDetail(reservationDetail)}
                              disabled={reservationDetail.remaining <= 0 || reservationDetail.bookFlag === 1}
                              checked={localSelectEqId === reservationDetail.eqsId}
                            />
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor={`space-selection_${reservationDetail.eqsId}`}
                              className={`p-space-selector__item  ${
                                reservationDetail.bookFlag === 1
                                  ? 'p-space-selector__item--reserved'
                                  : reservationDetail.nickName && 'p-space-selector__item--height-full'
                              }`}
                            >
                              {reservationDetail.annexFlag === 1 ? (
                                <span className="p-space-selector__tag c-genre-label">別館</span>
                              ) : (
                                <></>
                              )}
                              <div className="p-space-selector__main">
                                <div className="p-space-selector__space">{reservationDetail.eqsName}</div>
                                <div className="p-space-selector__white-box">
                                  <div className="p-space-selector__group">
                                    <div className="p-space-selector__status">
                                      {reservationDetail.remaining > 0 ? (
                                        <>
                                          残り
                                          <span className="p-space-selector__number">
                                            {reservationDetail.remaining}
                                          </span>
                                          名{' '}
                                        </>
                                      ) : (
                                        <span className="p-space-selector__sold-out">FULL</span>
                                      )}
                                    </div>
                                    <div className="p-space-selector__text">{reservationDetail.spaceName}</div>
                                  </div>

                                  {reservationDetail.nickName ? (
                                    <div
                                      className={`p-space-selector__user-group ${
                                        reservationDetail.remaining <= 0 ? 'p-space-selector__user-group--disabled' : ''
                                      }`}
                                    >
                                      {reservationDetail.nickName}
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                    {isFullBooked || reservationConfirmData?.companionUpperLimit === 0 ? (
                      <></>
                    ) : (
                      <div className="p-reservation-card__companion">
                        <div className="p-reservation-card__details-text u-pb0">同行者の人数を選択してください。</div>
                        <div className="p-item-unit">
                          <div className="c-select c-select--small">
                            <select
                              name="store"
                              className="c-select__window"
                              onChange={onChangeCompanionNum}
                              value={selectCompanionNum}
                            >
                              {companionNumList.map((num, index) => (
                                <option key={`companionNum_${num}`} value={num}>
                                  {num}
                                </option>
                              ))}
                            </select>
                          </div>
                          <span className="p-item-unit__text">名</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {reservationConfirmData.contentsComment && reservationConfirmData.contentsComment.length > 0 ? (
                  <section className="p-notice">
                    <div className="p-notice__title">予約に関する注意事項</div>
                    <ul className="p-notice__list">
                      {reservationConfirmData.contentsComment &&
                        reservationConfirmData.contentsComment
                          .split('\n')
                          .filter((line) => line.trim() !== '')
                          .map((line, index) => {
                            // 使用行内容和索引组合生成相对唯一的 key
                            const uniqueKey = `${line.slice(0, 20)}-${index}`;
                            return (
                              <li key={uniqueKey} className="p-notice__item p-notice__item--size14">
                                {line}
                              </li>
                            );
                          })}
                    </ul>
                  </section>
                ) : (
                  <></>
                )}
              </div>
            )}
            <div className="p-modal-member__button-area">
              <button
                type="button"
                className="c-button c-button--secondary c-button--large c-button--prev-gray"
                onClick={onCloseModal}
              >
                戻る
              </button>

              {!isGetReservationConfirmLoaded || isFullBooked ? (
                <></>
              ) : (
                <button
                  type="button"
                  className={`c-button c-button--primary c-button--large ${!isFullBooked ? 'c-button--next' : ''}`}
                  onClick={openReservationCompletePop}
                >
                  次へ
                </button>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ScheduleReservationPop;
